module.exports = __webpack_public_path__ + "static/media/Vanillite_gaussian2.be5f675d.png";